// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { parseResultsPublicationIndex, } from "@/types/results";
import { graphqlFetch } from "./graphql";
import { RESOLVE_RESULTS_PUBLICATION, } from "@/queries/resultsPublication";
import { publicBucketUrl } from "./urls";
var isRouteMatch = function (publication, eeId, electionId) {
    var _a;
    if (electionId) {
        if (publication.route_scope === "election") {
            return (publication.route_election_id === electionId ||
                publication.route === "/".concat(eeId, "/elections/").concat(electionId));
        }
        return (publication.route_scope === "event" &&
            ((_a = publication.election_ids) === null || _a === void 0 ? void 0 : _a.includes(electionId)) === true);
    }
    return publication.route_scope === "event" || publication.route === "/".concat(eeId);
};
export var fetchPublicIndex = function (settings, eeId) { return __awaiter(void 0, void 0, Promise, function () {
    var url, response, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                url = publicBucketUrl(settings.PUBLIC_BUCKET_URL, "results-index/".concat(eeId, ".json"));
                if (!url) {
                    return [2 /*return*/, null];
                }
                return [4 /*yield*/, fetch(url, { cache: "no-store" })];
            case 1:
                response = _b.sent();
                if (response.status === 404) {
                    return [2 /*return*/, null];
                }
                if (!response.ok) {
                    throw new Error("Unable to load results index: HTTP ".concat(response.status));
                }
                _a = parseResultsPublicationIndex;
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
        }
    });
}); };
export var findIndexPublication = function (index, eeId, electionId) {
    var _a, _b, _c, _d, _e;
    var matches = (_b = (_a = index === null || index === void 0 ? void 0 : index.publications) === null || _a === void 0 ? void 0 : _a.filter(function (publication) { return isRouteMatch(publication, eeId, electionId); })) !== null && _b !== void 0 ? _b : [];
    if (!electionId) {
        return (_c = matches[0]) !== null && _c !== void 0 ? _c : null;
    }
    return ((_e = (_d = matches.find(function (publication) {
        return publication.route_scope === "election" &&
            publication.route_election_id === electionId;
    })) !== null && _d !== void 0 ? _d : matches.find(function (publication) { return publication.route_scope === "event"; })) !== null && _e !== void 0 ? _e : null);
};
export var resolveManifestUrl = function (settings, publication) {
    var _a, _b;
    return (_a = publication.manifest_url) !== null && _a !== void 0 ? _a : publicBucketUrl(settings.PUBLIC_BUCKET_URL, (_b = publication.manifest_public_path) !== null && _b !== void 0 ? _b : undefined);
};
export var discoverPublication = function (settings, eeId, electionId, token) { return __awaiter(void 0, void 0, Promise, function () {
    var index, indexEntry, data, resolverEntry;
    var _a, _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0: return [4 /*yield*/, fetchPublicIndex(settings, eeId)];
            case 1:
                index = _d.sent();
                indexEntry = findIndexPublication(index, eeId, electionId);
                if ((indexEntry === null || indexEntry === void 0 ? void 0 : indexEntry.access) === "public") {
                    return [2 /*return*/, {
                            source: "public-index",
                            index: index !== null && index !== void 0 ? index : undefined,
                            indexEntry: indexEntry,
                            manifestUrl: resolveManifestUrl(settings, indexEntry),
                        }];
                }
                if ((indexEntry === null || indexEntry === void 0 ? void 0 : indexEntry.access) === "authenticated" && !token) {
                    return [2 /*return*/, {
                            source: "public-index",
                            index: index !== null && index !== void 0 ? index : undefined,
                            indexEntry: indexEntry,
                        }];
                }
                if (!token) return [3 /*break*/, 3];
                return [4 /*yield*/, graphqlFetch(settings.HASURA_URL, RESOLVE_RESULTS_PUBLICATION, { eeId: eeId, electionId: electionId }, token)];
            case 2:
                data = _d.sent();
                resolverEntry = data.resolveResultsPublication;
                if (!resolverEntry) {
                    return [2 /*return*/, null];
                }
                return [2 /*return*/, {
                        source: "resolver",
                        index: index !== null && index !== void 0 ? index : undefined,
                        resolverEntry: resolverEntry,
                        manifest: (_a = resolverEntry.manifest) !== null && _a !== void 0 ? _a : undefined,
                        manifestUrl: (_b = resolverEntry.manifest_url) !== null && _b !== void 0 ? _b : publicBucketUrl(settings.PUBLIC_BUCKET_URL, (_c = resolverEntry.manifest_public_path) !== null && _c !== void 0 ? _c : undefined),
                    }];
            case 3: return [2 /*return*/, indexEntry
                    ? {
                        source: "public-index",
                        index: index !== null && index !== void 0 ? index : undefined,
                        indexEntry: indexEntry,
                    }
                    : null];
        }
    });
}); };
